<template>
  <div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNum"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, prev, pager, next, sizes, jumper"
      :total="total"
      hide-on-single-page
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  props: {
    pageNum: { default: 1, type: Number },
    pageSize: { default: 10, type: Number },
    total: { default: 100, type: Number },
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.$emit("handleSizeChange", val);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.$emit("handleCurrentChange", val);
    },
  },
};
</script>
<style lang="scss" scoped></style>
